// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__g2Do_","spacer":"loading-dots_spacer__OOMMi","blink":"loading-dots_blink__5zENt"};